export default __webpack_public_path__ + "static/media/motorcycle.9e726d65.png";